import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";

export default class StaffService extends AbstractService {
	static contactsEndpoint = ENDPOINTS.staff;

	static getStaff({ organizationId, search, pageNumber, displayCount = 25 }) {
		return this.get({
			endpoint: `${ENDPOINTS.organizations}/${organizationId}/contacts`,
			queryParams: {
				search,
				pageNumber,
				displayCount,
			},
		});
	}

	static deleteStaff(id) {
		return this.del({
			endpoint: `${this.contactsEndpoint}/${id}`,
		});
	}

	static replaceStaff(id, replacementId) {
		return this.del({
			endpoint: `${this.contactsEndpoint}/${id}?replacementId=${replacementId}`,
		});
	}
}
